import React from "react";
import { LifeBuoy } from "lucide-react"; // Asegúrate de importar el icono correcto

interface HelpButtonProps {
  showHelp: boolean;
  setShowHelp: (value: boolean) => void;
}

const HelpButton: React.FC<HelpButtonProps> = ({ showHelp, setShowHelp }) => {
  return (
    <div className="fixed bottom-8 right-8 z-50">
      {/* Botón de ayuda */}
      <button 
        type="button" 
        title="Need Help?" 
        aria-label="Need Help?"
        onMouseEnter={() => setShowHelp(true)}
        onMouseLeave={() => setShowHelp(false)}
        className="p-4 bg-navy-900 text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300"
      >
        <LifeBuoy className="w-6 h-6" />
      </button>

      {/* Tarjeta de soporte */}
      {showHelp && (
        <div className="absolute bottom-full right-0 mb-4 w-64 bg-white p-6 rounded-xl shadow-2xl border border-gray-100">
          <h3 className="text-lg font-semibold text-navy-900 mb-2">Instant Support</h3>
          <p className="text-sm text-gray-600">Need help? Our team is ready to assist you.</p>
          <button 
            type="button" 
            title="Chat Now" 
            className="mt-3 w-full bg-navy-900 text-white px-4 py-2 rounded-lg hover:bg-navy-700 transition-colors"
          >
            Chat Now
          </button>
        </div>
      )}
    </div>
  );
};

export default HelpButton;
